import React from 'react';
import authRoles from '../../../auth/authRoles';
import CreateEvents from './CreateEvents';
import UpdateEvents from './UpdateEvent';

const EventsConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/calendar-addevent',
			// component: CreateEvents
			element: (
				<React.Suspense fallback={<>...</>}>
					<CreateEvents />
				</React.Suspense>
			),
			// component: React.lazy(() => import('./CreateEvents')),
		},
		{
			path: '/calendar-updateevent/:id',
			// component: UpdateEvents
			element: (
				<React.Suspense fallback={<>...</>}>
					<UpdateEvents />
				</React.Suspense>
			),
			// component: React.lazy(() => import('./UpdateEvent')),
		},
	],
	auth: authRoles.subadmin,
};

export default EventsConfig;
